export default __webpack_public_path__ + "static/collage-10-b766f05f76281c963c9a098070b9e36e.jpg";